import RecordHistoryModel from 'models/RecordHistoryModel';

export default class IUFApprovalHistoryModel extends RecordHistoryModel {}
